import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "pr-4 bg-gray-50 h-full pt-6 rounded-tl-none rounded-tr-[8px] rounded-br-[8px] rounded-bl-none"
};
const _hoisted_2 = {
  key: 0,
  class: "justify-items-start pt-1"
};
const _hoisted_3 = {
  class: "text-xs"
};
const _hoisted_4 = {
  class: "rounded-full bg-indigo-100 ml-2 px-1.5 py-0.5 text-sm"
};
const _hoisted_5 = {
  class: "flex justify-center",
  "data-cy": "m365-event-date-picker"
};
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center"
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 1,
  class: "text-base px-2 text-center text-gray-500"
};
import { useEntriesStore } from '@/services/useEntriesStore';
import LlTooltip from '@/components/LlTooltip.vue';
import EventCard from './EventCard.vue';
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import LlDatePicker from '@/components/LlDatePicker.vue';
export default {
  __name: 'M365Detail',
  emits: ['createNewTimeEntry', 'openEntryEditor'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      externalEventsList,
      loadingExternalEventsList
    } = storeToRefs(useEntriesStore());
    const entriesStore = useEntriesStore();
    const selectedDate = ref(new Date());
    const dismissingEventId = ref(null);
    const emit = __emit;
    const handleAddEntry = event => {
      emit('createNewTimeEntry', {
        externalEvent: event
      });
    };
    async function fetchEventsForDate(date) {
      entriesStore.setEventsDate(date);
      await entriesStore.listExternalEvents();
    }
    async function dismissEvent(eventId) {
      if (dismissingEventId.value) return;
      dismissingEventId.value = eventId;
      try {
        await entriesStore.dismissExternalEvent(eventId);
      } finally {
        dismissingEventId.value = null;
      }
    }
    onMounted(async () => {
      // Fetch events for today on component mount
      await fetchEventsForDate(selectedDate.value);
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["flex flex-row", [_unref(externalEventsList).length ? 'justify-between' : 'justify-end']])
      }, [_unref(externalEventsList).length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_cache[1] || (_cache[1] = _createTextVNode(" From my calendar ", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(externalEventsList).length), 1)])])) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_5, [_createVNode(LlDatePicker, {
        modelValue: selectedDate.value,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => selectedDate.value = $event), fetchEventsForDate],
        multiple: false,
        label: 'Event Date',
        showButton: false,
        showTextField: true
      }, null, 8, ["modelValue"])]), _unref(loadingExternalEventsList) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_v_progress_circular, {
        size: 40,
        width: 3,
        "bg-color": '#E0FFE0',
        indeterminate: "",
        color: "success"
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_unref(externalEventsList).length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(externalEventsList), data => {
        return _openBlock(), _createElementBlock("div", {
          key: data.externalId
        }, [data.state === 'Saved' ? (_openBlock(), _createBlock(LlTooltip, {
          key: 0,
          text: "Click to open Time Entry"
        }, {
          activator: _withCtx(({
            props
          }) => [_createElementVNode("div", _mergeProps({
            ref_for: true
          }, props, {
            class: "cursor-pointer hover:bg-gray-100",
            onClick: $event => _ctx.$emit('openEntryEditor', {
              entryId: data.entryId
            })
          }), [_createVNode(EventCard, {
            event: data,
            "is-disabling": dismissingEventId.value !== null,
            onAddEntry: handleAddEntry,
            onDismiss: dismissEvent
          }, null, 8, ["event", "is-disabling"])], 16, _hoisted_9)]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(EventCard, {
          key: 1,
          event: data,
          "is-disabling": dismissingEventId.value !== null,
          onAddEntry: handleAddEntry,
          onDismiss: dismissEvent
        }, null, 8, ["event", "is-disabling"]))]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, " There are no new events for today. "))]))]);
    };
  }
};